import { Component, OnInit } from '@angular/core';
import { CartService } from '../../services/cart.service';
import { environment } from 'src/environments/environment';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { AlertService } from 'src/app/core/services/alert.service';

@Component({
    selector: 'out-of-stock',
    templateUrl: './out-of-stock.component.html',
    styleUrls: ['./out-of-stock.component.scss', '../../cart.component.scss'],
    standalone: false
})
export class OutOfStockComponent implements OnInit {
  loading = false;
  nextPage = 1;
  productList = []
  totalProductPages = 1;
  totalProductCount = 0;
  noRecord = true;
  page_size = environment.page_size
  imagePath = environment.s3_path + '/' + environment.product_image_folder + '/'
  constructor(private cartService: CartService, private statePersist: StatePersistService,
    private alertService: AlertService) { }

  ngOnInit(): void {
    this.getOutOfStocks()
    this.statePersist.watchOtOfStockDetail().subscribe(message => {
      this.nextPage = 1;
      this.productList = []
      this.totalProductPages = 1;
      this.totalProductCount = 0;
      this.getOutOfStocks()
      this.statePersist.emitmobileListCountDetails('mobile count change')
    })
  }

  getOutOfStocks() {
    let formdata;
    formdata = {"page_size" : this.page_size, "page":this.nextPage}
    this.cartService.getOutOfStocks(formdata)
    .subscribe(
      data => {
        if (data.response) {
          if (data.status == 2212){
            this.alertService.error(data.response)
          }
          const product_list = data.response.out_of_stocks;
          this.totalProductCount = data.response.product_count
          this.totalProductPages = data.response.total_pages;
          if (this.totalProductPages < this.nextPage + 1) {
            this.nextPage = null;
          }
          else {
            this.nextPage += 1;
          }
          if (data.response.total_product_count === 0) {
            this.noRecord = true;
            this.productList = [];
            this.nextPage = 1;
            this.totalProductCount = 0;
            this.totalProductPages = 1
          }
          else {
            this.noRecord = false;

          }
          for (let i = 0; i < product_list.length; i++) {
            this.productList.push(product_list[i]);
          }
        }
        this.loading = false;
      }
    );
  }

  onScrollDown() {
    if ((this.nextPage != 1 && this.nextPage !== null) && !this.loading) {
      this.loading = true;
      this.getOutOfStocks()
    }

  }
}
